<template>
  <v-container fluid :class="{ 'modal-container': isInModal, 'container-full-bg-gray': !isInModal }">
    
    <CreationObject 
      :objectType="objectType" 
      objectName="Cliente"
      :url="url" 
      :id="customer"
      :third-name="cru_name"
      :third-cif="cru_cif"
      :document_id="document_id"
      :is-in-modal="isInModal"
      :is-header-fixed="isInModal ? true : false"
      @createdObject="mycreated" 
      :company_nif="nif"
      :company_name="name"
      :areParamsChanged="areParamsChanged"
      @updateParams="$emit('updateParams')"
      @cancel="$emit('cancel')"
      :hideSaveBtn="got_feature('feature_not_create_thirds_and_masters')"
    >
      <template #tabs-title>
        <div class="px-8 pt-2 tabs-title-div-bck">
          <v-row align="center">
            <v-col cols="12" class="pt-0">
              <v-tabs v-model="currentTab">
                <v-tab key="data">Datos</v-tab>
                <v-tab key="parameters">Parámetros</v-tab>
                <v-tab key="bank_info" v-if="hasEInvoiceContract && cru_data">Información bancaria</v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:inputs v-if="currentCompany">
        <app-row v-if="Object.keys(cru_errors_customerScreenValues).length">
          <v-expand-transition>
            <app-col cols="12" class="pt-8" v-show="Object.keys(cru_errors_customerScreenValues).length">
              <v-alert
                outlined
                prominent
                text
                type="error"
              > 
                <div v-for="error in cru_errors_customerScreenValues" :key="error.toString()">
                  <div v-if="Array.isArray(error)">{{firstAppearance(error)}}</div>
                  <div v-else>{{error}}</div>
                </div> 
              </v-alert>
            </app-col>
          </v-expand-transition>
        </app-row>
        <v-tabs-items class="ma-0 pa-0" v-model="currentTab">
          <v-tab-item class="ma-0 pa-0" key="data">
            <app-row class="pt-0 mt-0" v-if="got_feature('feature_generic_thirds')">
              <v-col cols="12" sm="6" md="4" class="col-check-btn">
                <v-checkbox 
                  autocomplete="off"
                  :label="cru_label_is_generic" 
                  v-model="cru_is_generic"
                  :readonly="['glasof', 'glasof_autonomos'].indexOf(currentCompany.companydb_type.value) > -1"  
                  @change="change_boolean('is_generic')"   
                  class="my-2 ml-2"
                  :hide-details="true"
                ></v-checkbox>

                <v-tooltip right v-if="['glasof', 'glasof_autonomos'].indexOf(currentCompany.companydb_type.value) > -1">
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn 
                      v-bind="attrs"
                      v-on="on"
                      icon 
                      color="primary"
                      >
                      <v-icon>mdi-information-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>Campo configurable desde Glasof, marcar "Pedir Nif en apuntes"</span>
                </v-tooltip>
              </v-col>
            </app-row>
            <app-row class="pt-0 mt-0" v-if="got_feature('feature_can_user_company_data')">
              <app-col cols="12" lg="4">
                <app-btn
                  color="primary"
                  class="btn-save"
                  :disabled="cru_cif===''"
                  @click="autocompleteCustomerData()"
                >
                  Autocompletar
                </app-btn>
                <message-popup 
                  title="Aviso"
                  :show_message="showAutocompletePupup"  
                  :message="`<p>¿Está seguro que quiere modificar los campos con los siguientes datos?</p>
                            <ul>
                              <li>CIF: ${company_data && company_data['cif']}</li>
                              <li>Nombre: ${company_data && company_data['name']}</li>
                              <li>Nombre comercial: ${company_data && company_data['comercial_names']}</li>
                              <li>Dirección: ${company_data && company_data['address']}</li>
                              <li>CP: ${company_data && company_data['zip_code']}</li>
                              <li>Ciudad: ${company_data && company_data['city']}</li>
                              <li>Provincia: ${company_data && company_data['province']}</li>
                              <li>Pais: ${company_data && company_data['country']}</li>
                              <li>Email: ${company_data && company_data['email']}</li>
                              <li>Teléfono: ${company_data && company_data['phones']}</li>
                              <li>Website: ${company_data && company_data['websites']}</li>
                            </ul>`"
                  :actions="[{ 'action_text': 'Cancelar', 'emit': 'close-message' }, { 'action_text': 'Aceptar', 'emit': 'confirm-update-data', 'prin': true }]"
                  @close-message="confirmCompanyData(false)" 
                  @confirm-update-data="confirmCompanyData(true)"
                ></message-popup>
                <message-popup 
                  title="Aviso"
                  :show_message="showDataNotFoundMessage"  
                  :message="`<p>No se ha encontrado ninguna referencia al CIF indicado</p>
                            <p>CIF : ${cru_cif}</p>`"
                  :actions="[{ 'action_text': 'Aceptar', 'emit': 'close-message','prin': true },]"
                  @close-message="showDataNotFoundMessage = false" 
                ></message-popup>
              </app-col>
            </app-row>
            <app-row contains-input-fields >
              <app-col contains-input-fields cols="12" lg="4" >
                <app-doc-text-field 
                  v-model="cru_cif"
                  kind="text"
                  :label="cru_label_cif" 
                  :error="Boolean(cru_error_cif)"
                  :error-messages="cru_error_cif"
                  @input="check_duplicates"
                ></app-doc-text-field>
                <div style="margin-top:-28px;color:#f34336">
                {{duplicate_message}}
                </div>
              </app-col>
              <app-col contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_name" 
                  v-model="cru_name"
                  append-icon="mdi-format-letter-case-upper"
                  append-icon-tooltip-text="Transformar texto a mayúsculas"
                  :error="Boolean(cru_error_name)"
                  :error-messages="cru_error_name"
                  @click:append="upper()"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                      <app-doc-text-field 
                        kind="text"
                        :disabled="!feature_customer_reference"
                        :label="cru_label_reference" 
                        v-model="cru_reference"
                        :error="Boolean(cru_error_reference)"
                        :error-messages="cru_error_reference"
                      ></app-doc-text-field>
                    </div>
                  </template>
                  <span>Asignará a este cliente los documentos que contengan esta referencia</span>
                </v-tooltip> 
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col has-input-fields-above contains-input-fields cols="12" lg="4" class="d-flex flex-sm-nowrap align-baseline">
                <app-autocomplete
                  autocomplete="off"
                  :label="cru_label_type"  
                  v-model="cru_type"
                  :items="thirdTypeTypes"
                  :readonly="false"
                  :error="Boolean(cru_error_type)"
                  :error-messages="cru_error_type"
                  class="flex-grow-1"
                >
              </app-autocomplete>
              <v-tooltip top v-if="cru_type && (cru_type == 'fisica' || (hasEInvoiceContract && cru_type == 'juridica'))">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    @click="showAdditionalInfo = true"
                    v-bind="attrs"
                    v-on="on"
                    icon 
                    color="primary"
                    >
                    <v-icon>mdi-information-variant</v-icon>
                  </v-btn>
                </template>
                <span>Datos ampliados</span>
              </v-tooltip>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" :lg="feature_account_type_innuva && !customer ? 8 : 4">
                <app-doc-text-field
                  v-if="!theCompanyIsOfTheRevisoType()"
                  kind="account"
                  third="customer"
                  :label="cru_label_debit_account"
                  v-model="cru_debit_account"
                  :error="Boolean(cru_error_debit_account)"
                  :error-messages="cru_error_debit_account"
                  :readonly="customer && !(cru_data && cru_data['from_facturae'])"
                  :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                  :enable_account_types="feature_account_type_innuva && !customer"
                  :account_types="account_types"
                  @input="onAccountChange"
                />
                <app-autocomplete
                  v-else
                  :label="cru_label_customer_group"
                  v-model="cru_customer_group"
                  :items="group_accounts_in_reviso"
                  :disabled="group_accounts_in_reviso.length < 1 || !!customer"
                  :error="Boolean(cru_error_customer_group)"
                  :error-messages="cru_error_customer_group"
                  @change="onRevisoGroupChange"
                />
                <AccountPrefixValidator
                  :account-value="currentText"
                  :enabled-groups="['40','41']"
                />
              </app-col>
              <app-col
                v-if="theCompanyIsOfTheRevisoType()"
                contains-input-fields has-input-fields-above cols="12" :lg="4"
              >
                <app-doc-text-field
                  kind="account"
                  :label="cru_label_debit_account"
                  v-model="cru_debit_account"
                  :error="Boolean(cru_error_debit_account)"
                  :error-messages="cru_error_debit_account"
                  :readonly="true"
                />
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_alias" 
                  v-model="cru_alias"
                  :error="Boolean(cru_error_alias)"
                  :error-messages="cru_error_alias"
                  :append-icon="!!name? 'mdi-lightbulb' : ''"
                  :append-icon-tooltip-text="!!name ? 'Obtener Nombre Comercial detectado en la factura' : ''"
                  @click:append="cru_alias = name" 
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_identity_key')">
                <app-autocomplete 
                  v-model="cru_identity_key"
                  class="autocomplete-input pa-0"
                  autocomplete="off"
                  :label="cru_label_identity_key"  
                  :items="identity_keys"
                  :readonly="false"  
                  :error="Boolean(cru_error_identity_key)"
                  :error-messages="cru_error_identity_key"
                ></app-autocomplete>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_address" 
                  v-model="cru_address"
                  :error="Boolean(cru_error_address)"
                  :error-messages="cru_error_address"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_zip_code" 
                  v-model="cru_zip_code"
                  :error="Boolean(cru_error_zip_code)"
                  :error-messages="cru_error_zip_code"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_city" 
                  v-model="cru_city"
                  :error="Boolean(cru_error_city)"
                  :error-messages="cru_error_city"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_province"  
                  v-model="cru_province"
                  :error="Boolean(cru_error_province)"
                  :error-messages="cru_error_province"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-autocomplete
                  autocomplete="off"
                  :label="cru_label_country" 
                  v-model="cru_country"
                  :items="autocompleteCountryItems"
                  class="autocomplete-input pa-0"
                  :error="Boolean(cru_error_country)"
                  :error-messages="cru_error_country"
                ></app-autocomplete>
              </app-col>
            </app-row>
            <app-row contains-input-fields>    
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_email" 
                  v-model="cru_email"
                  :error="Boolean(cru_error_email)"
                  :error-messages="cru_error_email"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_phone" 
                  v-model="cru_phone"
                  :error="Boolean(cru_error_phone)"
                  :error-messages="cru_error_phone"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_website" 
                  v-model="cru_website"
                  :error="Boolean(cru_error_website)"
                  :error-messages="cru_error_website"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="8">
                <app-doc-text-field 
                  kind="text"
                  :label="cru_label_notes" 
                  v-model="cru_notes"
                  :error="Boolean(cru_error_notes)"
                  :error-messages="cru_error_notes"
                ></app-doc-text-field>
              </app-col>
            </app-row>
          </v-tab-item>
          <v-tab-item class="ma-0 pa-0" key="parameters">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <app-doc-text-field
                  :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                  :label="cru_label_income_accounts"
                  v-model="cru_income_accounts"
                  :error="Boolean(cru_error_income_accounts)"
                  :error-messages="cru_error_income_accounts"
                  :is_array="true"
                  :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                  :num_digits="currentCompany.companydb_type.params && (currentCompany.companydb_type.params.hasOwnProperty('accounts_length') || currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length')) ? false : currentCompany.num_digits"
                  :items="got_feature('feature_accounts_master') ? accounts : []"
                  :account_prefix_filter="
                    currentCompany.companydb_type.value === 'aplifisa_fiscal' ? '7' :
                    (['estimasol', 'estimasol_nube'].includes(currentCompany.companydb_type.value) && !got_feature('feature_disable_validation_accounts_format')) ? 'I' :
                    ''"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  @input="onAccountChange"
                />

                <AccountPrefixValidator 
                  :account-value="currentText" 
                  :enabled-groups="['6']" 
                />
              </app-col>
            </app-row>
            <app-row contains-input-fields :style="refAccountsStyle" v-if="showRefAccountDetailLocal" >
              <app-col contains-input-fields cols="12" lg="6">
                <DetailReferenceAccounts
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :accounts="cru_ref_income_accounts"
                    :error="errorInRefAccounts"
                    @update="updateRefIncomeAccounts"
                    :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                    :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    :account_prefix_filter="['estimasol', 'estimasol_nube', 'aplifisa_fiscal'].includes(currentCompany.companydb_type.value) && !got_feature('feature_disable_validation_accounts_format') ? 'I' : ''"
                    @get-values="getValues"
                    @reset-items="resetItems"
                ></DetailReferenceAccounts>
              </app-col>
            </app-row>
            <!-- sergiiiiiiiiii -->
            <app-row contains-input-fields v-if="got_feature('feature_can_see_table_payment_methods')">
              <app-col contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <!-- :disabled="!feature_payment_move" -->
                <app-autocomplete
                  v-model="cru_automatic_charge_account"
                  :label="cru_label_automatic_charge_account"  
                  :items="automaticPaymentAccountTypes"
                  :error="Boolean(cru_error_automatic_charge_account)"
                  :error-messages="cru_error_automatic_charge_account"
                  :disabled="isDisabledAutomaticCharge()"
                  @change="onAutomaticChargeChange"
                ></app-autocomplete> 
              </app-col>
              <app-col  contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4" >
                <app-autocomplete
                  autocomplete="off"
                  :disabled="isDisabledCartera()"
                  :label="cru_label_charge_method"
                  v-model="cru_charge_method_id"
                  :items="payment_methods"
                  itemText="name"
                  itemValue="payment_method_id"
                  class="autocomplete-input"
                  :error="Boolean(cru_error_cartera)"
                  :error-messages="cru_error_cartera"
                  @change="onChargeMethodChange"
                />
              </app-col>
              <app-col contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <!-- :disabled="!feature_payment_move || (cru_automatic_charge_account && cru_automatic_charge_account != 'y')" -->
                <app-doc-text-field 
                  kind="account"
                  v-model="cru_charge_account"
                  :disabled="isDisabledCartera()"
                  :label="cru_label_charge_account"
                  hint="Únicamente aplica cuando la opción 'Sí' está activa"
                  :rules="accountRules"
                  :error="Boolean(cru_error_charge_account)"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <!-- sergiiiiiiiiii -->
            <app-row contains-input-fields v-else>
              <app-col contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <app-autocomplete
                  v-model="cru_automatic_charge_account"
                  :disabled="!feature_payment_move"
                  :label="cru_label_automatic_charge_account"  
                  :items="automaticPaymentAccountTypes"
                  :readonly="false"  
                  :error="Boolean(cru_error_automatic_charge_account)"
                  :error-messages="cru_error_automatic_charge_account"
                ></app-autocomplete> 
              </app-col>
              <app-col contains-input-fields :has-input-fields-above="$vuetify.breakpoint.mdAndDown" cols="12" lg="4">
                <app-doc-text-field 
                  kind="account"
                  v-model="cru_charge_account"
                  :disabled="!feature_payment_move || (cru_automatic_charge_account && cru_automatic_charge_account != 'y')"
                  :label="cru_label_charge_account"
                  hint="Únicamente aplica cuando la opción 'Sí' está activa"
                  :rules="accountRules"
                  :error="Boolean(cru_error_charge_account)"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
            </app-row>

            <!-- <app-row contains-input-fields :style="refAccountsStyle" v-if="showRefAccountDetailLocal" >
              <app-col contains-input-fields cols="12" lg="6">
                <DetailReferenceAccounts
                    :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                    :accounts="cru_ref_income_accounts"
                    :error="errorInRefAccounts"
                    @update="updateRefIncomeAccounts"
                    :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                    :max_length_account="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_max_length') ? currentCompany.companydb_type.params['accounts_max_length'] : false"
                    :items="got_feature('feature_accounts_master') ? accounts : []"
                    :account_prefix_filter="
                    currentCompany.companydb_type.value === 'aplifisa_fiscal' ? '7' :
                    (['estimasol', 'estimasol_nube'].includes(currentCompany.companydb_type.value) && !got_feature('feature_disable_validation_accounts_format')) ? 'I' :
                    ''"
                    @get-values="getValues"
                    @reset-items="resetItems"
                ></DetailReferenceAccounts>
              </app-col>
            </app-row> -->
            <app-row contains-input-fields>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4"  v-if="feature_customer_retention_type">
                <app-autocomplete
                  outlined
                  autocomplete="off"
                  :label="cru_label_retention_type"  
                  v-model="cru_retention_type"
                  :items="filtered_retention_types"
                  :readonly="false"  
                  class="autocomplete-input pa-0"
                  :error="Boolean(cru_error_retention_type)"
                  :error-messages="cru_error_retention_type"
                ></app-autocomplete>
              </app-col>
              <app-col 
                contains-input-fields 
                has-input-fields-above
                cols="12" lg="4"
                v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii"
              >
                  <app-select
                    v-model="cru_description_sii"
                    :items="[
                      { 'text': 'Descripción Factura', 'value': 'descr_factura' },
                      { 'text': 'Valor Fijo', 'value': 'valor_fijo' }
                    ]"
                    :label="cru_label_description_sii"
                    @change="changeDescriptionSII()"
                  ></app-select>
              </app-col>
              <app-col has-input-fields-above contains-input-fields
              cols="12" lg="4"
              v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_description_sii"
              >
                <app-doc-text-field
                    :disabled="cru_description_sii != 'valor_fijo'"
                    kind="text"
                    :label="cru_label_fixed_value"
                    v-model="cru_fixed_value"
                    :error="Boolean(cru_error_fixed_value)"
                    :error-messages="cru_error_fixed_value"
                  ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4"  v-if="currentCompany && currentCompany.available_features && currentCompany.available_features.feature_expense_income_type">
                <app-autocomplete
                    outlined
                    :clearable="true"
                    autocomplete="off"
                    :label="cru_label_expens_income_type"
                    v-model="cru_default_expens_income_type"
                    :items="getIncomeType"
                    item-text="name"
                    item-value="eit_id"
                    :readonly="false"
                    class="autocomplete-input pa-0"

                ></app-autocomplete>
              </app-col>
              <app-col
                  contains-input-fields
                  has-input-fields-above
                  cols="12" lg="4"
                  v-if="feature_cadastral_reference && cru_retention_type=='retention_rental_account'"
              >
                <app-doc-text-field
                    kind="string"
                    v-model="cru_cadastral_reference"
                    :label="cru_label_cadastral_reference"
                />
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-autocomplete
                  v-model="cru_auto_fill_due_date"
                  autocomplete="off"
                  :disabled="!feature_can_auto_fill_due_date"
                  :label="cru_label_auto_fill_due_date"  
                  :items="[{'text': 'N/A', 'value': 'na'}, {'text': 'Si', 'value': 'y'}, {'text': 'No', 'value': 'n'}]"
                  :readonly="false"  
                  :error="Boolean(cru_error_auto_fill_due_date)"
                  :error-messages="cru_error_auto_fill_due_date"
                ></app-autocomplete> 
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  kind="number"
                  v-model="cru_min_price"
                  :disabled="!feature_price_range"
                  :label="cru_label_min_price"
                  :error="Boolean(cru_error_min_price)"
                  :error-messages="cru_error_min_price"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  kind="number"
                  :label="cru_label_max_price"
                  v-model="cru_max_price"
                  :error="Boolean(cru_error_max_price)"
                  :error-messages="cru_error_max_price"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_actividad_selector') && activities.length > 0 && (currentCompany && !currentCompany.hide_activities_master)">
                <app-autocomplete
                  :label="cru_label_default_actividad"
                  v-model="cru_default_actividad"
                  :items="activities"
                  item-value="code"
                  item-text="name"
                  :clearable="true"
                />
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-else-if="currentCompany && !currentCompany.hide_activities_master">
                <app-doc-text-field
                  kind="string"
                  v-model="cru_default_actividad"
                  :label="cru_label_default_actividad"
                  />
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_project_channel_in_third') && got_feature('feature_document_projects') && hasMasterPermission('project') && !currentCompany.hide_projects_master">
                <app-autocomplete
                  :label="cru_label_default_project"
                  v-model="cru_default_project"
                  :items="projects"
                  item-value="id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_project_channel_in_third') && got_feature('feature_channel') && hasMasterPermission('channel') && !currentCompany.hide_channels_master">
                <app-autocomplete
                  :label="cru_label_default_channel"
                  v-model="cru_default_channel"
                  :items="channels"
                  item-value="channel_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_section_in_third') && got_feature('feature_sections') && hasMasterPermission('section') && !currentCompany.hide_sections_master">
                <app-autocomplete
                  :label="cru_label_default_section"
                  v-model="cru_default_section"
                  :items="sections"
                  item-value="section_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_delegation_in_third') && got_feature('feature_delegations') && hasMasterPermission('delegation') && !currentCompany.hide_delegations_master">
                <app-autocomplete
                  :label="cru_label_default_delegation"
                  v-model="cru_default_delegation"
                  :items="delegations"
                  item-value="delegation_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col contains-input-fields has-input-fields-above cols="12" lg="4" v-if="got_feature('feature_default_department_in_third') && got_feature('feature_departments') && hasMasterPermission('department') && !currentCompany.hide_departments_master">
                <app-autocomplete
                  :label="cru_label_default_department"
                  v-model="cru_default_department"
                  :items="departments"
                  item-value="department_id"
                  item-text="name"
                  :clearable="true"
                ></app-autocomplete>
              </app-col>

              <app-col 
                contains-input-fields has-input-fields-above
                cols="12" lg="4" 
                v-if="feature_payment_method && hasMasterPermission('payment_method')"
              >
                <app-text-field
                  outlined
                  :label="cru_label_payment_method"
                  v-model="cru_payment_method"
                  autocomplete="off"
                  class="autocomplete-input pa-0"
                  :error="Boolean(cru_error_payment_method)"
                  :error-messages="cru_error_payment_method"
                />
              </app-col>
              <app-col contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  :disabled="!showSuplidoAccount"
                  autocomplete="off"
                  v-model="cru_suplido_account"
                  :label="cru_label_suplido_account"
                  kind="account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
              <app-col  contains-input-fields has-input-fields-above cols="12" lg="4">
                <app-doc-text-field
                  v-if="got_feature('feature_retention_accounts_customer')"
                  autocomplete="off"
                  v-model="cru_retention_customer_account"
                  :label="cru_label_retention_customer_account"
                  kind="account"
                  :num_digits="currentCompany.companydb_type.params && currentCompany.companydb_type.params.hasOwnProperty('accounts_length') ? false : currentCompany.num_digits"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col 
                contains-input-fields has-input-fields-above cols="12" lg="4"
                v-if="got_feature('feature_ignore_cif_validation')"
                class="checkbox-col"
              >
                <v-checkbox
                  :label="cru_label_ignore_cif_validation"
                  v-model="cru_ignore_cif_validation"
                ></v-checkbox>
              </app-col>
            </app-row>
            <app-row>
              <app-col has-input-fields-above cols="12" lg="6">
                <app-creation-object-section-card outlined class="rounded-lg">
                  <template #title>
                    <span class="mx-4">Posición fiscal</span>
                  </template>
                  <v-container>
                    <v-row class="ma-0 pa-0" align="center">
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_inversion_sujeto_pasivo_iva" 
                          v-model="cru_inversion_sujeto_pasivo_iva"
                          :readonly="false"  
                          @change="change_boolean('inversion_sujeto_pasivo_iva')" 
                          class="pa-0 ma-0 my-2" 
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_intracomunitario"  
                          v-model="cru_intracomunitario"
                          :readonly="false"    
                          @change="change_boolean('intracomunitario')"  
                          class="pa-0 ma-0 my-2" 
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_dry_0_percent" 
                          v-model="cru_dry_0_percent"
                          @change="change_boolean('dry_0_percent')"
                          :readonly="false"  
                          class="pa-0 ma-0 my-2" 
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_inversion_sujeto_pasivo_igic" 
                          v-model="cru_inversion_sujeto_pasivo_igic"
                          :readonly="false"
                          @change="change_boolean('inversion_sujeto_pasivo_igic')"  
                          class="pa-0 ma-0 my-2" 
                          :hide-details="true"     
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="getExtracomunitarioLabel" 
                          v-model="cru_extracomunitario"
                          :readonly="false"  
                          @change="change_boolean('extracomunitario')"
                          class="pa-0 ma-0 my-2" 
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox 
                          autocomplete="off"
                          :label="cru_label_no_sujeta"
                          :disabled="!(feature_no_sujeta || got_feature('feature_exenta_no_sujeta'))"
                          v-model="cru_no_sujeta"
                          :readonly="false"
                          @change="change_boolean('no_sujeta')"
                          class="pa-0 ma-0 my-2" 
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0">
                        <v-checkbox
                          autocomplete="off"
                          :disabled="!got_feature('feature_apl_re_0')"
                          :label="cru_label_apl_re_0"
                          v-model="cru_apl_re_0"
                          :readonly="false"
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="ma-0 pa-0" v-if="got_feature('feature_foreign_entity')">
                        <v-checkbox
                          autocomplete="off"
                          :label="cru_label_foreign_entity"
                          v-model="cru_foreign_entity"
                          :readonly="false"
                          @change="change_boolean('foreign_entity')"
                          class="pa-0 ma-0 my-2"
                          :hide-details="true"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0 mt-4">
                      <v-col cols="12" lg="4" class="ma-0 pa-0" v-if="cru_intracomunitario && feature_intra_type">
                        <app-autocomplete
                          outlined
                          autocomplete="off"
                          :label="cru_label_intracomunitario_type"
                          v-model="cru_intracomunitario_type"
                          :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                          :readonly="false"
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :error="Boolean(cru_error_intracomunitario_type)"
                          :error-messages="cru_error_intracomunitario_type"
                        />
                      </v-col>
                      <v-col cols="12" lg="4" class="ma-0 pa-0" v-if="cru_extracomunitario && (feature_extra_type || feature_extracomunitario_type)">
                        <app-autocomplete
                          outlined
                          autocomplete="off"
                          :label="cru_label_extracomunitario_type"
                          v-model="cru_extracomunitario_type"
                          :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                          :readonly="false"
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                          :error="Boolean(cru_error_extracomunitario_type)"
                          :error-messages="cru_error_extracomunitario_type"
                        />
                      </v-col>
                      <v-col cols="12" lg="4" class="ma-0 pa-0" v-if="cru_foreign_entity && got_feature('feature_foreign_entity')">
                        <app-autocomplete
                          outlined
                          autocomplete="off"
                          :label="cru_label_foreign_entity_type"
                          v-model="cru_foreign_entity_type"
                          :items="[{text: 'Bienes', value: 'bienes'}, {text: 'Servicios', value: 'servicios'}]"
                          :readonly="false"
                          class="autocomplete-input pa-0"
                          @change="areParamsChanged=true"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0" v-if="feature_no_sujeta && feature_no_sujeta_reference && !cru_no_sujeta">
                      <v-col class="ma-0 pa-0" cols="12" >
                        <DetailReferenceSimple :ref_list="cru_refs_no_sujeta" @update="updateRefNoSujeta"></DetailReferenceSimple> 
                      </v-col>
                    </v-row>
                  </v-container>                    
                </app-creation-object-section-card>                
              </app-col>        
            </app-row>
          </v-tab-item>
          <v-tab-item class="ma-0 pa-0" key="bank_info" v-if="cru_data">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6" >
                <app-doc-text-field 
                  kind="text"
                  v-model="cru_data['iban']"
                  label="IBAN"
                  ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields cols="6" >
                <app-doc-text-field 
                  kind="text"
                  v-model="cru_data['bic']"
                  label="BIC"
                  ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6" >
                <app-doc-text-field 
                  kind="text"
                  v-model="cru_data['mandate_id']"
                  label="ID mandato SEPA"
                  ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields cols="6" >
                <app-doc-text-field 
                  kind="text"
                  hint="AAAA-MM-DD"
                  v-model="cru_data['mandate_signature_date']"
                  label="Fecha firma mandato SEPA"
                  :error="Boolean(wrong_format_signature_date)"
                  ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6" >
                <app-select
                  v-model="cru_data['payment_means']"
                  :items="payment_means_options"
                  :label="'Método de pago'"
                  dense
                  hide-details
                  @change="areParamsChanged = true"
                />
              </app-col>
            </app-row>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </CreationObject>

    <v-dialog v-model="showAdditionalInfo" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">
          <span class="text-h5 primary--text py-1 ml-2">Datos ampliados</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <template v-if="cru_type=='fisica'">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12">
                <app-text-field
                  label="Nombre"
                  type="text"
                  v-model="cru_first_name"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12">
                <app-text-field
                  label="Primer Apellido"
                  type="text"
                  v-model="cru_first_surname"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12">
                <app-text-field
                  label="Segundo Apellido"
                  type="text"
                  v-model="cru_second_surname"
                >
                </app-text-field>
              </app-col>
            </app-row>
          </template>
          <template v-if="cru_type=='juridica'">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_alias"
                  type="text"
                  v-model="cru_alias"
                >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_dire"
                  type="text"
                  v-model="cru_dire"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_accounting_office"
                  type="text"
                  v-model="cru_accounting_office"
                >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_management_body"
                  type="text"
                  v-model="cru_management_body"
                >
                </app-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_processing_unit"
                  type="text"
                  v-model="cru_processing_unit"
                >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="6">
                <app-text-field
                  :label="cru_label_proposing_body"
                  type="text"
                  v-model="cru_proposing_body"
                >
                </app-text-field>
              </app-col>
            </app-row>
          </template>
        </v-card-text>
        <v-card-actions class="pr-8">
          <v-spacer></v-spacer>
          <app-btn outlined @click="showAdditionalInfo=false">Cancelar</app-btn>
          <app-btn 
            color="primary"
            @click="updateWithAdditionalInfo"
          >
            Guardar
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreationObject from '../components/CreationObject.vue';
import AppAutocomplete from '@/components/layout/AppAutocomplete.vue';
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import AppCreationObjectSectionCard from '@/components/layout/AppCreationObjectSectionCard.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import { mapState, mapGetters, mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import { validateAccount } from "../utils/account_validation"
import DetailReferenceAccounts from '../components/DetailReferenceAccounts.vue'
import DetailReferenceSimple from '../components/DetailReferenceSimple.vue'
import { client, query_dispatcher } from "@/api/client";
import { AutocompleteCompanyData } from '@/modules/companies/application/AutocompleteCompanyData';
import MessagePopup from '@/components/MessagePopup.vue';
import { PAYMENT_MEANS_OPTIONS } from "@/modules/facturae/domain/Invoiceable";
import AccountPrefixValidator from '../components/AccountPrefixValidator.vue'
import { showActivitiesSage200 as showActivitiesSage200Helper } from "@/store/modules/documents";
import { PaymentMethodAPI } from "@/modules/company/infra/PaymentMethodAPI";
import { RevisoApi } from "@/modules/company/infra/RevisoApi";

export default {
  components: {
    AppAutocomplete,
    AppCreationObjectSectionCard,
    AppTextField,
    AppSelect,
    AppRow,
    AppCol,
    AppBtn,
    CreationObject,
    AppDocTextField,
    DetailReferenceAccounts,
    DetailReferenceSimple,
    MessagePopup,
    AutocompleteCompanyData,
    AccountPrefixValidator
  },
  props: {
    customer: {
      type: [Number, String],
    },
    name: {
      type: String,
    },
    nif: {
      type: String,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    document_id: {
      type: [String, Number],
      required: false,
      default: null
    },
  },
  data() {
    return {
      objectType: "Customer",
      url: "customers/",
      enabled_charge_account: false,
      areParamsChanged: false,
      account_types: [
        {text: '4300 - Clientes', value: '4300?'},
        {text: '440 - Deudores', value: '440?'},
      ],
      duplicate_message:'',
      currentTab: 'data',
      showAutocompletePupup: false,
      resolvePopupPromise:undefined,
      company_data:undefined,
      showDataNotFoundMessage: false,
      showAdditionalInfo: false,
      hasEInvoiceContract: false,
      payment_means_options: PAYMENT_MEANS_OPTIONS,
      currentText: '',
      payment_methods: [],
      reviso_api: null,
      group_accounts_in_reviso: [],
    };
  },
  methods: {
    onAccountChange(textUpdated) {
      this.currentText = textUpdated
    },
    ...mapActions({
      get_identity_keys: 'cru/get_identity_keys',
      updateScreenValuesArray: "cru/updateScreenValuesArray",
    }),
    ...mapActions("cru", ['getAccounts']),
    upper(){
      this.cru_name = this.cru_name.toUpperCase()
    },
    mycreated(id) {
      if (this.$router.currentRoute.name == 'document-detail') {
        this.$emit('createdObject', id);
      } else {
        this.$router.replace({ name: "customer-update", params: {'customer':id.id} })
      }  
    },
    changeDescriptionSII() {
      if (this.cru_description_sii == 'descr_factura' && this.cru_fixed_value) {
        this.cru_fixed_value = '';
      }
    },
    change_boolean(value) {
      console.log("----------->", this.cru_foreign_entity, value)
      if (value != 'inversion_sujeto_pasivo_iva') {
        this.cru_inversion_sujeto_pasivo_iva = false;
      }
      if (value != 'inversion_sujeto_pasivo_igic') {
        this.cru_inversion_sujeto_pasivo_igic = false;
      }
      if (value != 'intracomunitario') {
        this.cru_intracomunitario = false;
      }
      if (value != 'extracomunitario') {
        this.cru_extracomunitario = false;
      }
      if (value != 'no_sujeta') {
        this.cru_no_sujeta = false;
      }
      if (value != 'dry_0_percent') {
        this.cru_dry_0_percent = false;
      }
      if (value != 'foreign_entity') {
        this.cru_foreign_entity = false;
      }
      this.areParamsChanged = true;
    },
    check_duplicates(val){
      if(val.length > 7 && val.length < 10 ){
        let cdb_id = this.currentCompany.id.toString()
        let own_id = this.customer
        if (!this.customer){
          own_id = '-1'
        }
        client.get('customers_with_same_cif/?companydb_id=' +cdb_id+ '&cif='+val+'&own_id='+own_id).then(response=>{
                        if(this.cru_cif == val){
                          this.duplicate_message = response.data.results
                        }
                    },
                    error=>{
                        console.debug(error)
                    })
      }
      else{
        this.duplicate_message = ''
      }
    },
    updateRefIncomeAccounts(val){
      this.updateScreenValuesArray({field:'ref_income_accounts',value:val})
    },
    updateRefNoSujeta(val){
      this.updateScreenValuesArray({field:'refs_no_sujeta',value:val})
    },
    firstAppearance(list){
      for(let i in list){
        if(list[i]){
          return list[i]
        }
      }
      return ''
    },
    getValues(params) {
      console.log("getValues")
      console.log(params)
      this.getAccounts(params).then(() => {});
    },
    resetItems(params) {
      this.accounts = params;
    },
    showNotFoundMessage() {
      this.showDataNotFoundMessage = true
    },
    confirm(company_data){
      this.showAutocompletePupup = true;
      this.company_data = company_data.data
      return new Promise((resolve,reject)=>{
        this.resolvePopupPromise = resolve
      })
    },
    confirmCompanyData(res){
      this.showAutocompletePupup = false;
      this.resolvePopupPromise(res)
    },
    async autocompleteCustomerData() {
      try {
        await new AutocompleteCompanyData(query_dispatcher,this).run(this.cru_cif)
      } catch(error) {
        console.error('Error autocomplete customer data:', error);
      }
    },
    updateWithAdditionalInfo() {
      if (this.cru_type == 'fisica') {
        this.cru_name = `${this.cru_first_surname} ${this.cru_second_surname}, ${this.cru_first_name}`
      } else if (this.cru_type == 'juridica') {
        this.cru_name = this.cru_alias
      }
      this.showAdditionalInfo = false
    },
    hasMasterPermission(master) {
      return this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && 
      this.currentCompany.companydb_type.params.show.includes(master);
    },
    showActivitiesSage200() {
      return showActivitiesSage200Helper(
        this.currentCompany,
        this.userData
      );
    },
    async setAutomaticPayment(){
      if(this.currentCompany && this.currentCompany.id){
        if(this.cru_automatic_charge_account && this.cru_automatic_charge_account == "na" && this.currentCompany && this.currentCompany.automatic_charge_account && this.currentCompany.automatic_charge_account == 'y'){
          // this.cru_automatic_charge_account = this.currentCompany.automatic_charge_account
          if(this.cru_charge_method_id == '' && this.currentCompany.cartera_customer){
            this.cru_charge_method_id = this.currentCompany.payment_method_id_customer
            this.cru_cartera = this.currentCompany.cartera_customer
          }
          // if(this.cru_charge_account == '' && this.currentCompany.cuenta_cartera_customer){
          //   this.cru_charge_account = this.currentCompany.cuenta_cartera_customer
          // }
        }
      }
    },
    isDisabledCartera(){
      return this.cru_automatic_charge_account && this.cru_automatic_charge_account != 'y'
    },
    isDisabledAutomaticCharge(){
      return this.currentCompany && this.currentCompany.automatic_charge_account && this.currentCompany.automatic_charge_account == 'n'
    },
    onAutomaticChargeChange(){
      if(this.cru_automatic_charge_account == 'na'){
        this.cru_charge_method_id = this.currentCompany.payment_method_id_customer
        this.onChargeMethodChange()
        //this.cru_charge_account = this.currentCompany.cuenta_cartera_customer
      } else if(this.cru_automatic_charge_account != 'y'){
        this.cru_charge_method_id = ''
        this.cru_cartera = ''
        //this.cru_charge_account = ''
      }
    },
    async setPaymentMethods(){
      if(this.currentCompany && this.currentCompany.id){
        let args = { companydb_id: this.currentCompany.id }
        this.payment_methods = await this.paymentMethodAPI.getPaymentMethodsByCompanyDB(args)
      }
    },
    onChargeMethodChange(){
      let payment_methods = this.payment_methods.filter(payment_method => payment_method.payment_method_id == this.cru_charge_method_id)
      let external_id = ''
      if (payment_methods.length > 0){
          external_id = payment_methods[0].external_id
      }
      this.cru_cartera = external_id
    },
    async onRevisoGroupChange(selectedValue) {
      if (!selectedValue) {
        this.cru_debit_account = '';
        return;
      }
      const prefix = selectedValue.toString();
      try {
        const result = await client.get(`get_next_account/${this.currentCompany.id}/${prefix}/`);
        this.cru_debit_account = result.data.next_account;
      } catch (error) {
        console.error('Error getting next available account:', error);
      }
    },
    async getGroupAccountsInReviso(){
      if(this.currentCompany && this.currentCompany.id){
        let args = { companydb_id: this.currentCompany.id, path: "customer-groups" }
        this.group_accounts_in_reviso = await this.reviso_api.getAccountsFromThirdsGroupsInReviso(args) || []
      }
    },
    theCompanyIsOfTheRevisoType(){
      return this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.value == 'reviso'
    }
  },
  watch: {
    'currentCompany.id': {
      async handler(newVal) {
        if (newVal && this.theCompanyIsOfTheRevisoType()) {
          if (!this.reviso_api) {
            this.reviso_api = new RevisoApi()
          }
          await this.getGroupAccountsInReviso()
        }
      },
    },
  },
  created() {
    this.actualScreen = "customerScreenValues";
    this.cru_errors_customerScreenValues = {};
    this.get_identity_keys();
    this.accounts = [];
  },
  computed:{
    ...mapState(['currentCompany']),
    ...mapGetters({
      getCountryByCode: 'countries/getCountryByCode', 
      getCountries: 'countries/getCountries',
      get_automatic_charge_account_types: 'get_automatic_payment_account_types',
      getExtracomunitarioLabel: 'cru/getExtracomunitarioLabel',
      get_retention_types: 'get_retention_types',
      got_feature: 'got_feature',
      getIncomeType: 'getIncomeType',      
    }),
    ...mapGetters('cru',['screenValues',]),
    ...mapFields(['automaticPaymentAccountTypes', 'activities', 'projects', 'channels', 'sections', 'delegations', 'departments', 'thirdTypeTypes']),
    ...mapFields('cru',['actualScreen', 'identity_keys', 'accounts']),
    ...mapFields('cru',vuexPrefix('cru_',[
      'type', 'cif', 'name', 'alias', 'first_name', 'first_surname', 'second_surname', 'dire', 'accounting_office', 'management_body', 'processing_unit', 'proposing_body',
      'reference', 'income_accounts','ref_income_accounts', 'debit_account', 'inversion_sujeto_pasivo_iva', 
      'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario', 'intracomunitario_type', 'extracomunitario_type', 'no_sujeta','dry_0_percent', 'address', 'apl_re_0',
      'zip_code', 'city', 'province', 'country', 'email', 'website', 'phone', 'notes', 'review', 'automatic_charge_account', 'charge_method_id', 'charge_method', 'cartera', 
      'charge_account','payment_method', 'identity_key', 'auto_fill_due_date','default_actividad','suplido_account', 'retention_type',
      'max_price', 'min_price', 'description_sii', 'fixed_value','refs_no_sujeta', 'default_project', 'default_channel', 'default_section', 'default_delegation', 'retention_customer_account',
      'ignore_cif_validation', 'default_expens_income_type','data', 'is_generic', 'default_department','cadastral_reference', 'foreign_entity', 'foreign_entity_type', 'customer_group'
    ],'screenValues.customerScreenValues.')),
    ...mapFields('cru',vuexPrefix('cru_error_',[
      'type', 'cif', 'name', 'alias','reference' ,'ref_income_accounts', 'income_accounts', 'debit_account', 'inversion_sujeto_pasivo_iva', 
      'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario', 'intracomunitario_type', 'extracomunitario_type', 'no_sujeta','dry_0_percent', 'address', 'zip_code', 
      'city', 'province', 'country', 'email', 'website', 'phone', 'notes', 'review', 'automatic_charge_account', 'cartera', 'payment_method', 
      'charge_account', 'identity_key', 'auto_fill_due_date', 'retention_type', 'max_price', 'min_price', 'fixed_value', 'customer_group'
    ],'screenErrors.customerScreenValues.')),
    ...mapFields('cru', vuexPrefix('cru_errors_',[
      'customerScreenValues'
    ],'screenErrors.')),

    ...mapFields('cru',vuexPrefix('cru_label_',[
      'type', 'cif', 'name', 'alias', 'first_name', 'first_surname', 'second_surname', 'dire', 'accounting_office', 'management_body', 'processing_unit', 'proposing_body',
      'reference' ,'ref_income_accounts','income_accounts', 'debit_account', 'inversion_sujeto_pasivo_iva', 
      'inversion_sujeto_pasivo_igic', 'intracomunitario', 'extracomunitario', 'intracomunitario_type', 'extracomunitario_type', 'no_sujeta','dry_0_percent', 'address', 'zip_code', 
      'city', 'province', 'country', 'email', 'website', 'phone', 'notes', 'review', 'automatic_charge_account', 'cartera', 'charge_method', 'payment_method', 'charge_account', 'identity_key', 'auto_fill_due_date','default_actividad','suplido_account', 'max_price', 'min_price', 'apl_re_0', 'retention_type', 'description_sii', 'fixed_value', 'default_project', 'default_channel', 'default_section', 'default_delegation', 'retention_customer_account', 'ignore_cif_validation', 'expens_income_type', 'is_generic', 'default_department','cadastral_reference', 'foreign_entity', 'foreign_entity_type', 'customer_group'
    ],'inputLabels.')),
    ...mapFields('me',vuexPrefix('',[
      'feature_payment_move','feature_no_sujeta', 'feature_intra_type', 'feature_extra_type', 'feature_extracomunitario_type', 'feature_can_auto_fill_due_date', 'feature_identity_key','feature_no_sujeta_reference',
      'feature_income_accounts_reference', 'feature_actividad_str_field', 'feature_payment_method', 'feature_account_type_innuva',
      'feature_suplido_account', 'feature_customer_reference', 'feature_customer_retention_type', 'feature_price_range','feature_cadastral_reference',
    ],'userData.available_features.')),
    ...mapFields('me', ['userData']),
    wrong_format_signature_date() {
      if (this.cru_data['mandate_signature_date'] && !this.cru_data['mandate_signature_date'].match(/^\d{4}-\d{2}-\d{2}$/)) {
        return 'Formato incorrecto'
      }
      return ''
    },
    refAccountsStyle() {
      if (this.$vuetify.breakpoint.xs) {
        return 'margin-top:-15% !important'
      }

      if (this.$vuetify.breakpoint.xl) {
        return 'margin-top: -3% !important'
      }

      return 'margin-top:-4% !important'
    },

    showRefAccountDetailLocal(){
      return this.feature_income_accounts_reference && this.currentCompany && this.currentCompany.companydb_type.params && (!this.currentCompany.companydb_type.params.hide || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('income_account_reference')))
    },
    errorInRefAccounts(){
      return Object.keys(this.cru_errors_customerScreenValues).includes('ref_income_accounts')
    },
    showSuplidoAccount() {
      let show = false;
      if (this.feature_suplido_account && this.currentCompany && this.currentCompany.configuration && this.currentCompany.companydb_type.params) {
        show = ((!this.currentCompany.companydb_type.params.hasOwnProperty('hide')) || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('suplido_account')));
      }
      return show      
    }, 
    autocompleteCountryItems: function() {
      return this.getCountries.map((country_code) => {
        let country = this.getCountryByCode(country_code);
        return {"text": country.name, "value": country.code}
      });
    },
    accountRules() {
      return [
        (v) => !v ||  validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
      ]
    },
    retentionTypesItems: function() {
      return this.setChoices().then(() => {
        return this.get_retention_types;
      })   
    },
    filtered_retention_types() {
      let show_ret_types_agrario = this.currentCompany.iva_agrario_pesca && this.got_feature('feature_retention_accounts_agrario');
      let ret_types = [];
      for(let i in this.get_retention_types){
        let element = this.get_retention_types[i];
        if (['retention_agriculture_account', 'retention_livestock_account'].indexOf(element.value) > -1) {
          if (show_ret_types_agrario) {
            ret_types.push(element)
          }
        }
        else if (element.value != 'retention_transport_account') {
          ret_types.push(element)
        }
      }
      return ret_types;
    },
  },
  async mounted() {
    if(this.theCompanyIsOfTheRevisoType()){
      this.reviso_api = new RevisoApi()
      await this.getGroupAccountsInReviso()
    }
    if (this.currentCompany && this.userData) {
      let res = await query_dispatcher.dispatch('check.user.has.active.envoice.contract', { user_id: this.userData.id, company_id: this.currentCompany.id })
      this.hasEInvoiceContract = res['company']
    }
    this.paymentMethodAPI = new PaymentMethodAPI()
    await this.setPaymentMethods()
    await this.setAutomaticPayment()
  }

};
</script>

<style scoped>
  .title-tabs {
    padding-bottom: 0px;
  }
  .items-tabs {
    margin-top: 0px !important;
  }
  ::v-deep .v-tabs-bar__content {
      background: #F8F8FA;
  }
  .v-tab {
      text-transform: capitalize !important;
      font-weight: 400;
      font-size: 18px;
  }

  .modal-container {
    padding: 0px !important;
  }

  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }

  .checkbox-col {
    height:90px; 
  }
  
  .col-check-btn {
    align-items: center;
    display: flex;
    gap: 8px;
  }
</style>

<style>
  .vm--container {
    position: absolute !important;
    box-sizing: border-box !important;
    left: 0 !important;
    top: -14px !important;
    width: 100% !important;
    height: 100vh !important;
    z-index: unset !important;
  }

  .vm--overlay{
    background: unset !important;
  }

  .vm--modal {
    z-index: 4 !important;
    margin-top: 94px !important;
    height: 80vh !important;
    overflow: auto !important;
    top: unset !important;
  }

  .scrollable-card {
    height: unset !important;
    width: unset !important;
    cursor: move;
    padding: 5px !important;
  }
</style>